export default __webpack_public_path__ + "static/media/carCover.172d2c75.svg";